import React, { useState } from "react";
import _ from "lodash";
import { rootProductIds, RootProductId } from "@models";
import ModuleSetting from "../../../models/ModuleSetting";
import ModuleSettingCategorySection from "./ModuleSettingCategorySection";
import { Checkbox } from "@components";
import styled from "styled-components";

type Props = {
	moduleSettings: ModuleSetting[];
};

export default function ModuleSettingsList(props: Props) {
	const { moduleSettings } = props;
	const groupedModuleSettings = _.groupBy(moduleSettings, (ms) => ms.category);
	const [showActiveModuleSettings, setShowActiveModuleSettings] =
		useState(true);

	return (
		<>
			<StyledCheckbox
				id="showActiveProducts"
				label="Nur aktive zeigen"
				value={showActiveModuleSettings}
				onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
					setShowActiveModuleSettings(e.target.checked)
				}
			/>
			{rootProductIds.map((rootId: RootProductId) => (
				<ModuleSettingCategorySection
					key={rootId}
					rootProductId={rootId}
					moduleSettings={groupedModuleSettings[rootId] ?? []}
					showActiveModuleSettings={showActiveModuleSettings}
				/>
			))}
		</>
	);
}

const StyledCheckbox = styled(Checkbox)`
	margin-bottom: 16px;
`;
